import React, { Component } from 'react';
import { DomainPropType, VictoryAxis, VictoryBar, VictoryStack } from 'victory';
import { QualaRange } from '../../lib/qualaRange';
import { variables } from '../utils/Tachyons';
import QualaChart from './QualaChart';

interface IBinaryStackedChart {
  data: any;
  range: QualaRange;
  small?: boolean;
  short?: boolean;
}

export default class BinaryStackedChart extends Component<IBinaryStackedChart, {}> {
  public render() {
    const { range, data, short = false } = this.props;
    const tickCount = range.timescale === 'month' ? 5 : undefined;
    const domain: DomainPropType = { y: [0, 100] };

    return (
      <QualaChart domain={domain} short={short}>
        <VictoryAxis
          tickValues={range.ticks()}
          tickFormat={t => range.formatTick(t)}
          tickCount={tickCount}
          style={{
            grid: { stroke: 'transparent' }
          }}
        />

        {(!!data.no.length || !!data.yes.length) && (
          <VictoryStack>
            {!!data.yes.length && (
              <VictoryBar
                data={data.yes}
                x="date"
                y="value"
                style={{ data: { fill: variables.blue } }}
                animate={{
                  duration: 500,
                  onLoad: { duration: 750 }
                }}
              />
            )}

            {!!data.no.length && (
              <VictoryBar
                data={data.no}
                x="date"
                y="value"
                style={{ data: { fill: variables.washedBlue } }}
                animate={{
                  duration: 500,
                  onLoad: { duration: 750 }
                }}
              />
            )}
          </VictoryStack>
        )}
      </QualaChart>
    );
  }
}
